import paths from 'paths'
import { OrganizationManagementArea } from 'paths/link'
import { Navigate, useParams } from 'react-router-dom'

type RedirectParams = {
  area?: OrganizationManagementArea
}

export default function OrganizationManagementRouterRedirect({
  area = 'settings',
}: RedirectParams) {
  const params = useParams<{
    organizationSlug?: string
  }>()

  return (
    <Navigate
      to={paths.organizationManagement({
        slug: params.organizationSlug ?? '',
        area,
      })}
      replace
    />
  )
}
